export default "__VITE_ASSET__9de4d52f__"